import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { withRouteAccessCheck } from '../../../../app/Hoc/WithLoginAceessCheck';

const Subscriber = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card card-custom  bg-transparent sales-card  border-0 px-0">
            <div className="card-header min-h-1px bg-transparent border-0 px-0 ">
              <div className="card-title flex-fill">
                <form action="" className="col-12 px-0">
                  <div className="row align-items-end">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="">Service Address</label>
                        <input type="text" className="form-control" placeholder="Search..." />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="">Email Address</label>
                        <input type="email" className="form-control" placeholder="Search..." />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="">Phone Number</label>
                        <input type="text" className="form-control" placeholder="Search..." />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <buttom className="btn btn-custom electric_cobalt min-h-55px">
                          Search
                        </buttom>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="card-toolbar">
                <button className="btn btn-custom export min-h-55px">
                  Export{' '}
                  <span>
                    <img src="/images/export.svg" alt="" />
                  </span>
                </button>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="card card-custom card-xxl-stretch">
                <div className="card-body">
                  <div className="table-responsive">
                    <div className="hide-mobile">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Account</th>
                            <th className="text-center">Name</th>
                            <th className="text-center">Address</th>
                            <th className="text-center">Phone</th>
                            <th className="text-center">Email</th>
                            <th className="text-center">Services</th>
                            <th className="text-center">Subscriber Stats</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-blue">00000HUT-MAGNTXMS</td>
                            <td className="text-center text-blue">PROVISIONED</td>
                            <td className="text-center text-blue">
                              111 Avenue D10, Magnolia, TX 77355
                            </td>
                            <td className="text-center text-blue">(701) 526 5858</td>
                            <td className="text-center text-blue">john_official@hotmail.com</td>
                            <td className="text-center text-blue">Fiber</td>
                            <td className="text-center text-blue"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="hide-edsktop">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th>Account</th>
                            <td className="text-blue">00000HUT-MAGNTXMS</td>
                          </tr>
                          <tr>
                            <th>Name</th>
                            <td className="text-blue">PROVISIONED</td>
                          </tr>
                          <tr>
                            <th>Address</th>
                            <td className="text-blue">111 Avenue D10, Magnolia, TX 77355</td>
                          </tr>
                          <tr>
                            <th>Phone</th>
                            <td className="text-blue">(701) 526 5858</td>
                          </tr>
                          <tr>
                            <th>Email</th>
                            <td className="text-blue">john_official@hotmail.com</td>
                          </tr>
                          <tr>
                            <th>Services</th>
                            <td className="text-blue">Fiber</td>
                          </tr>
                          <tr>
                            <th>Subscriber Stats</th>
                            <td className="text-blue"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouteAccessCheck(Subscriber);
